(function() {
  'use strict';

  function normalizeLocale(value) {
    if (!value || typeof value !== 'string') return '';
    return value.trim().replace('_', '-').toLowerCase();
  }

  function detectLocale() {
    var candidates = [
      window.theme && window.theme.locale,
      window.Shopify && window.Shopify.locale,
      document.documentElement && document.documentElement.lang,
      window.location.pathname && window.location.pathname.split('/').filter(Boolean)[0],
      navigator.language
    ];

    for (var i = 0; i < candidates.length; i += 1) {
      var candidate = normalizeLocale(candidates[i]);
      if (candidate) return candidate;
    }

    return 'en';
  }

  function getBaseLocale(locale) {
    return normalizeLocale(locale).split('-')[0];
  }

  function getConfig() {
    var locale = detectLocale();
    var strings = window.theme && window.theme.i18n && window.theme.i18n.klaviyoOptin;

    if (!strings || !strings.titleWithDiscount) return null;

    return {
      locale: locale,
      baseLocale: getBaseLocale(locale),
      strings: strings
    };
  }

  function isTranslatableLocale(config) {
    return !!config;
  }

  function normalizeDiscount(rawDiscount) {
    if (!rawDiscount) return '';
    return String(rawDiscount).replace(/\s*off$/i, '').trim();
  }

  function format(template, replacements) {
    return String(template || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function(match, key) {
      return Object.prototype.hasOwnProperty.call(replacements, key) ? replacements[key] : match;
    });
  }

  function ensureResponsiveTeaserStyles() {
    if (document.getElementById('codex-klaviyo-teaser-styles')) return;

    var style = document.createElement('style');
    style.id = 'codex-klaviyo-teaser-styles';
    style.textContent = [
      '[data-codex-klaviyo-teaser-host="true"] {',
      '  inline-size: auto !important;',
      '  block-size: auto !important;',
      '  min-inline-size: 0 !important;',
      '  min-block-size: 0 !important;',
      '  max-inline-size: min(18rem, 70vw) !important;',
      '  padding: 0.875rem 0.75rem !important;',
      '  border-radius: 1rem !important;',
      '  display: inline-flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '  overflow: visible !important;',
      '}',
      '[data-codex-klaviyo-teaser-text="true"] {',
      '  display: block !important;',
      '  inline-size: auto !important;',
      '  max-inline-size: none !important;',
      '  white-space: nowrap !important;',
      '  word-break: keep-all !important;',
      '  overflow-wrap: normal !important;',
      '  text-align: center !important;',
      '  line-height: 1.05 !important;',
      '  font-size: clamp(0.9rem, 2.4vw, 1.35rem) !important;',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function findTeaserHost(element) {
    if (!element || !element.closest) return null;
    return element.closest('button, a, [role="button"], [role="dialog"], div');
  }

  function applyFlexibleTeaserLayout(element) {
    if (!element || element.nodeType !== 1) return;
    ensureResponsiveTeaserStyles();
    element.setAttribute('data-codex-klaviyo-teaser-text', 'true');

    var host = findTeaserHost(element);
    if (host) {
      host.setAttribute('data-codex-klaviyo-teaser-host', 'true');
    }
  }

  function replaceExactText(text, config) {
    var trimmed = text.trim();
    var normalized = trimmed.replace(/\s+/g, ' ');
    var titleMatch = normalized.match(/^unlock\s+(\d+%)(?:\s+off)?!?$/i);

    if (titleMatch) {
      return {
        text: format(config.strings.titleWithDiscount, { discount: normalizeDiscount(titleMatch[1]) }),
        kind: 'title'
      };
    }

    var teaserMatch = normalized.match(/^get\s+(\d+%)(?:\s+off)?!?$/i);

    if (teaserMatch) {
      return {
        text: format(config.strings.teaserWithDiscount || config.strings.titleWithDiscount, { discount: normalizeDiscount(teaserMatch[1]) }),
        kind: 'teaser'
      };
    }

    var bodyMatch = normalized.match(/^sign up to receive\s+(\d+%)(?:\s+off)?\s+your first order and exclusive access to our best offers\.?$/i);

    if (bodyMatch) {
      return {
        text: format(config.strings.bodyWithDiscount, { discount: normalizeDiscount(bodyMatch[1]) }),
        kind: 'body'
      };
    }

    if (/^email$/i.test(normalized)) return { text: config.strings.email, kind: 'field' };
    if (/^off!?$/i.test(normalized)) return { text: '', kind: 'teaser-fragment' };
    if (/^sign me up!?$/i.test(normalized)) return { text: config.strings.submit, kind: 'cta' };
    if (/^no,\s*thanks(?:\.\.\.)?!?$/i.test(normalized) || /^no thanks(?:\.\.\.)?!?$/i.test(normalized)) {
      return { text: config.strings.dismiss, kind: 'dismiss' };
    }

    return null;
  }

  function updateTextNode(node, config) {
    if (!node || !node.nodeValue || !node.nodeValue.trim()) return false;
    var original = node.nodeValue.trim();
    var replacement = replaceExactText(original, config);

    if (!replacement || replacement.text === original) return false;

    node.nodeValue = node.nodeValue.replace(original, replacement.text);
    if (replacement.kind === 'teaser' || replacement.kind === 'teaser-fragment') {
      applyFlexibleTeaserLayout(node.parentElement);
    }
    return true;
  }

  function updateAttributes(element, config) {
    if (!element || !element.getAttribute) return false;

    var changed = false;
    var attrs = ['placeholder', 'aria-label', 'value', 'title'];

    for (var i = 0; i < attrs.length; i += 1) {
      var attr = attrs[i];
      var value = element.getAttribute(attr);
      if (!value) continue;

      var replacement = replaceExactText(value, config);
      if (!replacement || replacement.text === value) continue;

      element.setAttribute(attr, replacement.text);
      if (attr === 'value' && 'value' in element) {
        element.value = replacement.text;
      }
      if (replacement.kind === 'teaser' || replacement.kind === 'teaser-fragment') {
        applyFlexibleTeaserLayout(element);
      }
      changed = true;
    }

    return changed;
  }

  function looksLikeKlaviyoContainer(element) {
    if (!element || element.nodeType !== 1) return false;

    var marker = [
      element.id || '',
      element.className || '',
      element.getAttribute && element.getAttribute('data-testid') || '',
      element.getAttribute && element.getAttribute('data-form-id') || ''
    ].join(' ').toLowerCase();

    if (marker.indexOf('klaviyo') !== -1) return true;
    if (marker.indexOf('form-version-cid') !== -1) return true;
    if (element.matches && element.matches('[data-testid*="form"], [role="dialog"], form')) {
      var textContent = (element.textContent || '').replace(/\s+/g, ' ').trim();
      var hasEmailField = !!(element.querySelector && element.querySelector('input[type="email"], input[name*="email" i]'));
      var hasKnownCopy = /unlock\s+\d+%\s+off|get\s+\d+%\s+off|sign up to receive\s+\d+%\s+off|sign me up|no,\s*thanks/i.test(textContent);

      if (hasEmailField && hasKnownCopy) return true;
    }

    return !!(element.querySelector && element.querySelector('[class*="klaviyo"], [id*="klaviyo"], form[action*="klaviyo"]'));
  }

  function containsKnownOptInCopy(element) {
    if (!element || element.nodeType !== 1) return false;
    var textContent = (element.textContent || '').replace(/\s+/g, ' ').trim();
    return /unlock\s+\d+%\s+off|get\s+\d+%\s+off|sign up to receive\s+\d+%\s+off|sign me up|no,\s*thanks/i.test(textContent);
  }

  function translateElementTree(root, config) {
    if (!root || (!looksLikeKlaviyoContainer(root) && !containsKnownOptInCopy(root))) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    while (walker.nextNode()) {
      updateTextNode(walker.currentNode, config);
    }

    var elements = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for (var i = 0; i < elements.length; i += 1) {
      updateAttributes(elements[i], config);
    }

    updateAttributes(root, config);
  }

  function runTranslation(config) {
    if (!isTranslatableLocale(config)) return;

    var roots = document.querySelectorAll('[class*="klaviyo"], [id*="klaviyo"], form[action*="klaviyo"], [role="dialog"], button, a, div');
    for (var i = 0; i < roots.length; i += 1) {
      translateElementTree(roots[i], config);
    }
  }

  function init() {
    var config = getConfig();
    if (!isTranslatableLocale(config)) return;

    runTranslation(config);

    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];

        if (mutation.type === 'childList') {
          for (var j = 0; j < mutation.addedNodes.length; j += 1) {
            var addedNode = mutation.addedNodes[j];
            if (addedNode && addedNode.nodeType === 1) {
              translateElementTree(addedNode, config);
            }
          }
        }

        if (mutation.type === 'characterData' && mutation.target && mutation.target.parentElement) {
          translateElementTree(mutation.target.parentElement, config);
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
